import React, { useEffect, useState } from 'react';
import { fetchGroups, createGroup, deleteGroup } from '../../api/group';
import { getAllUsers } from '../../api/auth';
import FileUploader from './FileUploader';
import AssignUserToGroup from '../AssignUserToGroup/AssignUserToGroup';
import UserGroupManager from '../UserGroupManager/UserGroupManager';
import styles from './AdminDashboard.module.css';
import { toast } from 'react-toastify';

const AdminDashboard = () => {
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [newGroupName, setNewGroupName] = useState(''); // ✅ new state
   const [selectedGroupId, setSelectedGroupId] = useState('');
  const [groupToDelete, setGroupToDelete] = useState(null); // 

  useEffect(() => {
    fetchGroups().then((res) => setGroups(res.data));
    getAllUsers().then((res) => setUsers(res.data));
  }, []);
  const handleCreateGroup = async (e) => {
    e.preventDefault();
    if (!newGroupName.trim()) return toast.warning('Please enter a group name.');

    try {
      const res = await createGroup({ name: newGroupName.trim() });
      setGroups([...groups, res.data]);
      toast.success('Group created successfully');
      setNewGroupName('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create group');
    }
  };

    const confirmDeleteGroup = async () => {
    try {
      await deleteGroup(groupToDelete._id);
      setGroups((prev) => prev.filter((g) => g._id !== groupToDelete._id));
      toast.success(`Group "${groupToDelete.name}" deleted`);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to delete group');
    } finally {
      setGroupToDelete(null); // close modal
    }
  };

   const selectedGroup = groups.find((g) => g._id === selectedGroupId);

  return (

    <div className={styles.dashboardCard}>
      <div className={styles.header}>
        <h2 className={styles.title}>Admin Dashboard</h2>

      </div>

      {/* ✅ Group Creation Form */}
     <form className={styles.groupForm} onSubmit={handleCreateGroup}>
        <input
          type="text"
          placeholder="Enter new group name"
          value={newGroupName}
          onChange={(e) => setNewGroupName(e.target.value)}
          className={styles.groupInput}
        />
        <button type="submit" className={styles.createButton}>
          + Create Group
        </button>
      </form>

      <div className={styles.groupDropdownContainer}>
        <label>Select Group to Delete:</label>
        <select
          value={selectedGroupId}
          onChange={(e) => setSelectedGroupId(e.target.value)}
          className={styles.groupDropdown}
        >
          <option value="">-- Choose a Group --</option>
          {groups.map((g) => (
            <option key={g._id} value={g._id}>
              {g.name}
            </option>
          ))}
        </select>

        {selectedGroupId && (
          <button
            className={styles.deleteButton}
            onClick={() => setGroupToDelete(selectedGroup)}
          >
            Delete Selected Group
          </button>
        )}
      </div>

      <div className={styles.section}>
        <FileUploader groups={groups} />
      </div>

      <div className={styles.section}>
        <AssignUserToGroup users={users} groups={groups} />
      </div>

      <div className={styles.section}>
        <UserGroupManager groups={groups} />
      </div>

      {/* Confirmation Modal */}
      {groupToDelete && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modal}>
            <h4>Confirm Deletion</h4>
            <p>
              Are you sure you want to delete the group{' '}
              <strong>{groupToDelete.name}</strong>?
            </p>
            <div className={styles.modalActions}>
              <button
                className={styles.cancelButton}
                onClick={() => setGroupToDelete(null)}
              >
                Cancel
              </button>
              <button className={styles.confirmButton} onClick={confirmDeleteGroup}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
